// A user-supplied SIM telephone number; never infer it from an ICCID or IMEI.
export function normalizeTrackerPhone(value) {
  if (value === null) return null;
  if (typeof value !== "string" || value.length > 40) throw new Error("invalid_tracker_phone");
  const number = value.replace(/[ ()-]/g, "");
  if (number === "") return null;
  if (!/^\+[1-9][0-9]{5,14}$/.test(number)) throw new Error("invalid_tracker_phone");
  return number;
}

export function trackerCallUrl(value) {
  const phone = normalizeTrackerPhone(value);
  return phone ? `tel:${phone}` : null;
}

export function deviceContactShape(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  try { if (normalizeTrackerPhone(value.phoneNumber) !== value.phoneNumber) return false; } catch { return false; }
  return Number.isSafeInteger(value.revision) && value.revision >= 0
    && (value.updatedAt === null || (typeof value.updatedAt === "string" && Number.isFinite(Date.parse(value.updatedAt))))
    && (value.updatedBy === null || (typeof value.updatedBy === "string" && value.updatedBy.length <= 254))
    && (value.revision !== 0 || (value.phoneNumber === null && value.updatedAt === null && value.updatedBy === null));
}
